import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private widthSubject = new BehaviorSubject<number>(window.innerWidth);
  width$ = this.widthSubject.asObservable();

  constructor(private ngZone: NgZone) {
    // Listen for resize events
    window.addEventListener('resize', () => {
      this.ngZone.run(() => {
        this.widthSubject.next(window.innerWidth);
      });
    });
  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /android|iphone|ipad|ipod/i.test(userAgent);
  }

  getDeviceWidth(): number {
    return this.widthSubject.value;
  }
}
